export default class Owner {
  email = "";
  name = "";
  businessUnitGroup? = "";
  businessUnit? = "";
  subBusinessUnit? = "";
  departmentGroup? = "";
}
